import { Box, SimpleGrid, ChakraProvider, extendTheme } from "@chakra-ui/react";
import { useState } from "react";

import { UserDto } from "doxecure-commons/doxecureClientTypes";
import { Nullable } from "foundation-ts/types";

import { initialState } from "@/components/SubcriptionCards/constants";
import { InvoicesCard } from "@/components/SubcriptionCards/InvoicesCard";
import { MandateCard }  from "@/components/SubcriptionCards/MandateCard";
import { PlanCard }     from "@/components/SubcriptionCards/PlanCard";
import { UsersCard }    from "@/components/SubcriptionCards/UsersCard";
import { Plan, Mandate, SubscriptionState } from "@/components/SubcriptionCards/types";

const theme = extendTheme({
    fonts: {
        heading: "'DM Serif Display', Georgia, serif",
        body: "'DM Sans', system-ui, sans-serif",
    },
    colors: {
        brand: {
            50: "#f0f4ff", 100: "#dce6ff", 500: "#3354f4",
            600: "#2441d9", 700: "#1a30b0", 900: "#0d1a5c",
        },
        surface: { base: "#F7EBE8", card: "#ffffff", subtle: "#f1f4fb" },
    },
    styles: { global: { body: { bg: "surface.base", color: "gray.800" } } },
    components: { Button: { baseStyle: { fontWeight: "500", borderRadius: "10px" } } },
});

interface SubscriptionTabProps {
    connectedUser?: Nullable<UserDto>;
}

export const SubscriptionTab = (props: SubscriptionTabProps) => {
    const { connectedUser } = props;
    const [sub, setSub]         = useState<SubscriptionState>(initialState);
    const [mandate, setMandate] = useState<Nullable<Mandate>>(connectedUser?.corporations?.first()?.mandate as Mandate);

    function handleChangePlan(plan: Plan): void {
        setSub((s) => ({ ...s, plan, isTrial: false }));
    }

    function handleStartNow(): void {
        setSub((s) => ({ ...s, isTrial: false }));
    }

    function handleCancel(): void {
        setSub((s) => ({ ...s, isTrial: false }));
    }

    function handleAddUsers(count: number): void {
        setSub((s) => ({ ...s, usersAuthorized: s.usersAuthorized + count }));
    }

    function handleRemoveUsers(count: number): void {
        setSub((s) => ({
            ...s,
            usersAuthorized: Math.max(s.plan.usersIncluded, s.usersAuthorized - count),
        }));
    }

    return (
        <ChakraProvider theme={theme}>
            <Box bg="surface.base" px={{ base: 4, md: 8, xl: 10 }} py={10} fontFamily="body">
                <SimpleGrid columns={{ base: 1, lg: 2}} spacing={5} mb={5}>
                    <PlanCard
                        sub={sub}
                        onChangePlan={handleChangePlan}
                        onStartNow={handleStartNow}
                        onCancel={handleCancel}
                    />
                    <UsersCard
                        sub={sub}
                        onAddUsers={handleAddUsers}
                        onRemoveUsers={handleRemoveUsers}
                    />
                    <MandateCard
                        mandate={mandate}
                        onUpdate={setMandate}
                    />
                </SimpleGrid>

                <InvoicesCard />
            </Box>
        </ChakraProvider>
    );
};